import {
  ChangeDetectorRef,
  inject,
  OnDestroy,
  Pipe,
  PipeTransform,
} from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { first, Subscription } from 'rxjs';

import { IndexedData } from '@VineyardLib/constant/constant';
import { messageData } from '@VineyardLib/data/message-data';
import { convertToString } from '@VineyardLib/utils/typeConversion.util';
/**
 * メッセージの翻訳をします。
 * ※翻訳の処理内容についてはngx-translateのtranslate.pipeを参考に実装
 * 　参考ソース：https://github.com/ngx-translate/core/blob/master/packages/core/lib/translate.pipe.ts
 */
@Pipe({
  name: 'messageTranslate',
  pure: false, // 翻訳が適切なタイミングで実行されるようにするためにfalseを設定　参照: https://angular.dev/api/core/Pipe#pure
})
export class MessageTranslatePipe implements PipeTransform, OnDestroy {
  private translateService = inject(TranslateService);

  private value = '';
  private lastMessageData?: messageData;
  private onLangChange?: Subscription;

  constructor(private changeDetectorRef: ChangeDetectorRef) {}

  transform(messageData: messageData | undefined): string {
    if (messageData == null || messageData.messageKey == null) {
      return '';
    }

    // 不要な呼び出しを避けるため、 翻訳対象が前回と同じ場合は翻訳しない
    if (messageData == this.lastMessageData) {
      return this.value;
    }

    // パラメータの翻訳を行う
    let translatedParams: IndexedData = {};
    if (messageData.replacementParams != null) {
      Object.entries(messageData.replacementParams).forEach(([key, value]) => {
        translatedParams[key] = this.translateService.instant(
          convertToString(value)
        );
      });
    }

    this.value = this.translateService.instant(
      messageData.messageKey,
      translatedParams
    );

    this.lastMessageData = messageData;

    this.dispose();

    if (!this.onLangChange) {
      // 翻訳ファイルがロード済みになったタイミング、言語が変更されたタイミングで、再度翻訳処理を走らせる
      this.onLangChange = this.translateService.onLangChange
        .pipe(first())
        .subscribe(() => {
          this.lastMessageData = undefined;
          this.changeDetectorRef.markForCheck();
        });
    }

    return this.value;
  }

  ngOnDestroy(): void {
    this.dispose();
  }

  private dispose(): void {
    if (this.onLangChange != null) {
      this.onLangChange.unsubscribe();
      this.onLangChange = undefined;
    }
  }
}
